<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <!-- <div class="select-box">
      <div class="select-label">审核状态</div>
      <Select  style="width:200px" clearable @on-clear="clearAuditState" @on-change="changeAuditState">
        <Option value="0">未提审</Option>
        <Option value="1">待审核</Option>
        <Option value="2">审核通过</Option>
        <Option value="3">审核驳回</Option>
      </Select>
    </div> -->
    <div class="select-box-name">
      <div class="select-label">{{appName}}</div>
      <img class="select_icon_url" :src="appIcon" />
    </div>
    <div class="option-wrap">
      <Row>
        <Col >
          <Button type="primary" :disabled="this.uid !== this.userId" @click="newAlert"><Icon type="md-add" size="15" /> 上传小程序新版本</Button>
        </Col>
        <!-- <Col style="margin:0 10px 0 10px">
          <Button type="primary" @click="generateApk"> 生成apk</Button>
        </Col>
        <Col >
          <Button type="primary" @click="apkVersion"> apk版本管理</Button>
        </Col> -->
      </Row>
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    <Modal
      width="600"
      :mask-closable="false"
      v-model="newdata"
      title="上传版本"
      :loading="loading"
      @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="版本号" prop="package_ver">
          <Input v-model="formValidate.package_ver" placeholder="请输入版本号，需三段，以小数点分隔。例如1.0.0" />
        </FormItem>
        <FormItem label="SDK最小版本" prop="sdk_ver_s">
          <!-- <Input v-model="formValidate.sdk_ver_s" :rows="4" /> -->
          <Select
                v-model="formValidate.sdk_ver_s"
                placeholder="请选择版本"
                filterable
                >
                <Option v-for="(option, index) in sdkVerList" :value="option.value" :tag="option" :key="index">{{option.text}}</Option>
            </Select>
        </FormItem>
        <!-- <FormItem label="SDK最大版本" prop="sdk_ver_e">
          <Input v-model="formValidate.sdk_ver_e" :rows="4" />
        </FormItem> -->
        <FormItem label="备注" prop="remark">
          <Input v-model="formValidate.remark" type="textarea" :rows="4" />
        </FormItem>
        <FormItem label="开启强制更新" prop="remark">
          <RadioGroup v-model="formValidate.refresh">
            <Radio label="开启"></Radio>
            <Radio label="关闭"></Radio>
        </RadioGroup>
        </FormItem>
        <FormItem label="上传代码包" prop="fileName">
          <label class="file-wrap">
            <input class="file-input" type="file" ref="file" accept=".zip" @change="uploadImg('file')" />
            <Button icon="ios-cloud-upload-outline">{{formValidate.fileName || '上传'}}</Button>
          </label>
          <div class="tips">文件格式为zip,将项目编译后dist文件夹中的android文件夹进行压缩上传到此处。</div>
        </FormItem>
      </Form>
    </Modal>
    <Modal
      width="1000"
      :mask-closable="false"
      :footer-hide="true"
      v-model="isShowApkVersion"
      title="apk版本管理"
      >
      <Table :loading="tableLoading" class="spacingTwice" border :columns="apksColumns" :data="apksList"></Table>
      <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
            @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="preShow"
      :title="pre_env === 'pro' ? '生成线上版本二维码' : '生成预览版本二维码'"
      :footer-hide="true">
      <Form ref="preValidate" :model="preValidate" :label-width="80">
        <FormItem label="" prop="params">
          <div style="display: flex; justify-content: space-between">
            <!-- <Input v-model="preValidate.params" placeholder="JSON字符串" style="width: 375px" /> -->
            <Button type="primary" @click="copyCode">一键复制分享链接</Button>
            <Button type="primary" style="margin-right:80px;" @click="getCode">生成二维码</Button>
          </div>
          <!-- <div class="tips">可通过参数实现到指定页面的效果，用于模拟外部点击进入指定页面<br>
            多页面例如：{"url":"info","query": {"token":"aabb"}}<br>
            单页面例如：{"roomId":"1122","token": "aabb"}
          </div> -->
        </FormItem>
        <FormItem label="二维码" prop="qrCode" v-show="preValidate.qrCode">
          <div class="code-box">
            <!-- <vue-qr :text="preValidate.qrCode" :margin="0" colorDark="#000" colorLight="#fff" :size="278"></vue-qr> -->
            <img :src="preValidate.qrCode">
            <p>使用微信小程序扫描此二维码</p>
          </div>
          <div class="tips">二维码可截图保存7天(128小时)内反复使用，新生成二维码后，旧二维码将无法使用</div>
        </FormItem>
      </Form>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="isShowFormApk"
      title="生成应用"
      :loading="loadingApk"
      :footer-hide="true"
      >
      <Form ref="formApk" :model="formApk" :rules="ruleApkValidate"  :label-width="120">
        <FormItem label="名称" prop="app_name">
          <Input v-model="formApk.app_name" :disabled="saveOrEdit" placeholder="请输入小程序名称" />
        </FormItem>
        <FormItem label="包名" prop="app_pkg">
          <Input v-model="formApk.app_pkg" :disabled="true" placeholder="请输入小程序名称" />
        </FormItem>
        <FormItem label="商店上架包名" prop="apk_pkg">
          <Input :disabled="saveOrEdit" v-model="formApk.apk_pkg" placeholder="请输入商店上架包名" />
        </FormItem>
        <FormItem label="icon" prop="app_icon">
          <label class="file-wrap">
            <input :disabled="saveOrEdit" class="file-input" type="file" ref="file1" accept="image/*" @change="uploadImg1('file1')" />
            <Button :disabled="saveOrEdit" icon="ios-cloud-upload-outline">{{formApk.fileName || '上传'}}</Button>
          </label>
          <div><img v-show="imgUrl" :src="imgUrl" style="border-radius:10px;margin-top:10px;" width="100" height="100"></div>
        </FormItem>
        <FormItem label="apk版本" prop="start_ver">
          <Input :disabled="saveOrEdit" v-model="formApk.start_ver" placeholder="请输入小程序版本" />
        </FormItem>
        <div style="margin-left:100px;color:#c00;margin-top:-17px;">上一个apk版本号为:{{top_ver}}</div>
        <FormItem label="启动参数" prop="startup_args">
          <Input :disabled="saveOrEdit" v-model="formApk.startup_args" type="textarea" :rows="2" />
        </FormItem>
        <FormItem label="选择渠道" prop="channel_ids">
          <CheckboxGroup v-model="formApk.channel_ids">
            <Checkbox v-for="(items) in channelList" :key="items.id" :label="items.name"></Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
      <div class="option-wrap">
        <Row v-show="!startApk">
          <Col style="margin-left:80%">
            <Button type="primary" v-show="saveOrEdit" @click="editBtn"> 修改</Button>
          </Col>
          <Col style="margin-left:80%">
            <Button type="primary" v-show="!saveOrEdit" @click="saveBtn"> 保存</Button>
          </Col>
        </Row>
      </div>
      <Row>
          <Col style="margin-left:38px;">
            <Button type="primary" :loading="apkDataloading" :disabled="saveOrEdit ? false: true" v-show="!startApk" @click="apkData('formApk')"> {{apkProgress === 100 ? '重新生成apk' : '生成apk'}}</Button>
            <Button type="primary" :disabled="true" v-show="startApk" > 生成中</Button>
          </Col>
          <Col style="width:200px;margin-left:10px;margin-top:4px;" v-show="startApk">
            <Progress :percent="apkProgress" status="active" :stroke-color="['#108ee9', '#87d068']" />
          </Col>
        </Row>
      <Row style="margin-top:10px;">
        <Col style="margin-left:38px;">
            <Button type="primary" :disabled="apkProgress === 100 ? false : true" @click="downApk" > 下载</Button>
          </Col>
      </Row>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="isShowApkInfo"
      title="apk信息"
      :footer-hide="true"
      >
      <Form ref="apkInfo" :model="apkInfo"  :label-width="120">
        <FormItem label="名称" prop="name_cn">
          <Input v-model="apkInfo.name_cn" :disabled="true" placeholder="请输入小程序名称" />
        </FormItem>
        <FormItem label="包名" prop="es_pkg">
          <Input v-model="apkInfo.es_pkg" :disabled="true" placeholder="请输入小程序名称" />
        </FormItem>
         <FormItem label="icon" prop="icon_url">
          <!-- <label class="file-wrap">
            <input :disabled="true" class="file-input" type="file" ref="file1" accept="image/*" @change="uploadImg1('file1')" />
            <Button :disabled="true" icon="ios-cloud-upload-outline">{{apkInfo.fileName || '上传'}}</Button>
          </label> -->
          <div>
            <img :src="apkInfo.icon_url" width="100">
            </div>
        </FormItem>
        <FormItem label="商店上架包名" prop="apk_pkg">
          <Input :disabled="true" v-model="apkInfo.apk_pkg" placeholder="请输入商店上架包名" />
        </FormItem>
        <FormItem label="渠道" prop="channel">
          <Input :disabled="true" v-model="apkInfo.channel" placeholder="请输入小程序名称" />
        </FormItem>
        <FormItem label="启动参数" prop="args">
          <Input :disabled="true" v-model="apkInfo.args" type="textarea" :rows="3" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../../https'
import vueQr from 'vue-qr'
export default {
  name: 'version',
  data () {
    const validateVer = (rule, value, callback) => {
      // if (this.formValidate.sdk_ver_s !== 'all' && this.formValidate.sdk_ver_e !== 'all' && parseInt(this.formValidate.sdk_ver_s) > parseInt(this.formValidate.sdk_ver_e)) {
      //   callback(new Error('SDK最小版本 不能大于 SDK最大版本'))
      // } else {
      //   callback()
      // }
      callback()
    }
    return {
      loading: true,
      tableLoading: true,
      isShowApkVersion: false,
      newdata: false,
      authorized: false,
      preShow: false,
      pre_env: '',
      selectItems: [],
      sdkVersion: [],
      package_ver: '',
      tvid: '',
      appName: '',
      appIcon: '',
      channelList: [],
      apksList: [],
      apkProgress: 0,
      search: {
        name: ''
      },
      formValidate: {
        package_ver: '',
        remark: '',
        fileName: '',
        files: '',
        sdk_ver_s: '',
        sdk_ver_e: '',
        refresh: '关闭'
      },
      formApk: {
        app_name: '',
        app_pkg: '',
        app_icon: '',
        apk_pkg: '',
        channel_ids: [],
        fileName: '',
        startup_args: '',
        files: '',
        start_ver: ''
      },
      sdkVerList: [],
      isShowFormApk: false,
      loadingApk: false,
      isShowApkInfo: false,
      apkInfo: {},
      startApk: false,
      apkDataloading: false,
      ruleValidate: {
        package_ver: [
          { required: true, message: '请输入版本号', trigger: 'blur' }
        ],
        fileName: [
          { required: true, message: '请上传代码包' }
        ],
        sdk_ver_s: [
          { validator: validateVer }
        ],
        sdk_ver_e: [
          { validator: validateVer }
        ]
      },
      ruleApkValidate: {
        app_name: [
          { required: true, message: '请输入应用名称', trigger: 'blur' }
        ],
        app_pkg: [
          { required: true, message: '请输入包名' }
        ],
        apk_pkg: [
          { required: true, message: '请输入商店上架包名' }
        ],
        app_icon: [
          { required: true, message: '请上传应用icon' }
        ],
        start_ver: [
          { required: true, message: '请输入小程序版本' }
        ]
      },
      preValidate: {
        params: '',
        qrCode: ''
      },
      top_ver: '1.0.0',
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          title: '版本号',
          key: 'package_ver',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '状态',
          key: 'package_stats',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let package_stats = ''
            switch (params.row.package_stats) {
              case 0:
                package_stats = '预览版本'
                break
              case 1:
                package_stats = '测试版本'
                break
              case 2:
                package_stats = '线上版本'
                break
              case 3:
                package_stats = '历史版本'
                break
            }
            return h('span', package_stats)
          }
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 300
        },
        {
          title: 'SDK版本',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let name = ''
            if (!params.row.sdk_ver_s && !params.row.sdk_ver_e) {
              name += '不限'
            } else {
              if (params.row.sdk_ver_s) {
                name += params.row.sdk_ver_s
              } else {
                name += '不限'
              }
              if (params.row.sdk_ver_e) {
                name += (' - ' + params.row.sdk_ver_e)
              } else {
                name += ' - 不限'
              }
            }
            return h('span', name)
          }
        },
        {
          title: '上传时间',
          key: 'created_at',
          width: 200,
          align: 'center'
        },
        // {
        //   title: '审核时间',
        //   key: 'aduit_at',
        //   width: 200,
        //   align: 'center',
        //   render: (h, params) => {
        //     return h('span', params.row.aduit_stats === 2 ? params.row.aduit_at : '-')
        //   }
        // },
        {
          title: '发布时间',
          key: 'pub_at',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.package_stats === 2 || params.row.package_stats === 3 ? params.row.pub_at : '-')
          }
        },
        {
          title: '操作',
          width: 320,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let btn = []
            if (params.row.aduit_stats === 2) {
              if (params.row.package_stats === 3) {
                btn = [
                  h('Button', {
                    props: {
                      type: 'success',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '版本回退后不可再次回退',
                          content: '可回到上一个已发布的线上版本，且不可再次回退。',
                          onOk: () => {
                            https.request({
                              method: 'get',
                              url: '/v2/es/appvertest/rollback',
                              params: {
                                tvid: params.row.tvid,
                                package_ver: params.row.package_ver
                              }
                            }).then(res => {
                              this.$Message.success('版本回退成功')
                              this.loadData()
                            }).catch(error => {
                              this.$Message.error(error)
                            })
                          }
                        })
                      }
                    }
                  }, '版本回退')
                ]
              }
            }
            btn.push(h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: (this.uid !== this.userId)
              },
              style: {
                marginRight: '10px'
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '提示',
                    content: `<p class="del-modal-txt">确定把【${this.appName} - ${params.row.package_ver}】同步至正式分组？</p>`,
                    onOk: () => {
                      https.request({
                        method: 'post',
                        url: `v2/es/appvertest/syncProd?id=${params.row.id}`
                      }).then(res => {
                        // this.sdkVerList = res.result
                        this.loadData()
                      })
                    }
                  })
                }
              }
            }, '同步正式'))
            if (params.row.package_stats === 0 || params.row.package_stats === 2 || params.row.package_stats === 3) {
              btn.push(h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.getPreCode(params.row.package_stats === 0 ? 'pre' : 'pro', params.row)
                  }
                }
              }, '投屏查看'))
            }
            return h('div', btn)
          }
        }
      ],
      apksColumns: [ // 版本管理table表格
        {
          title: '渠道',
          key: 'channel',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: 'apk类型',
          key: 'apk_type',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let apk_type = ''
            switch (params.row.apk_type) {
              case 1:
                apk_type = '大apk'
                break
              case 0:
                apk_type = '空apk'
                break
            }
            let html = [
              h('span', apk_type)
            ]
            return html
          }
        },
        {
          title: '版本号',
          key: 'apk_ver_name',
          width: 220,
          align: 'center'
        },
        {
          title: '打包状态',
          key: 'task_status',
          width: '100px',
          align: 'center',
          render: (h, params) => {
            let apk_task_type = ''
            switch (params.row.task_status) {
              case 0:
                apk_task_type = '构建中'
                break
              case 1:
                apk_task_type = '成功'
                break
              case 2:
                apk_task_type = '失败'
                break
            }
            let html = [
              h('span', apk_task_type)
            ]
            return html
          }
        },
        {
          title: '生成时间',
          key: 'created_at_str',
          width: 220,
          align: 'center'
        },
        {
          title: '操作',
          width: 180,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let btn = []
            btn = [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.isShowApkInfo = true
                    this.apkInfo = JSON.parse(params.row.args)
                    this.apkInfo.channel = params.row.channel
                  }
                }
              }, 'apk信息')
            ]
            if (params.row.apk_url.length > 0) {
              btn.push(h('a', {
                attrs: {
                  href: params.row.apk_url,
                  target: '_blank'
                },
                on: {
                  click: () => {
                  }
                }
              }, '下载'))
            }
            return h('div', btn)
          }
        }
      ],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1, // 当前页
      saveOrEdit: false,
      imgUrl: '',
      uid: '',
      userId: ''
    }
  },
  components: {
    breadcrumb,
    vueQr
  },
  watch: {
    isShowFormApk (nval, oval) {
      if (oval) {
        this.saveOrEdit = false
      }
    }
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.tvid = this.$route.query.tvid
    this.uid = this.$route.query.uid
    this.userId = localStorage.getItem('userId')
    this.appName = this.$route.query.name
    this.appIcon = this.$route.query.icon
    this.getVersion()
    this.getVerList()
    this.loadData()
  },
  methods: {
    getVerList () {
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/extPublic/getDictItems?dicCode=runtime_sdk_version'
      }).then(res => {
        console.log(res)
        this.sdkVerList = res.result
      })
    },
    downApk () {
      // this.$refs['formApk'].resetFields()
      this.isShowFormApk = false
      this.apkVersion()
    },
    saveBtn () {
      this.saveOrEdit = true
    },
    editBtn () {
      this.saveOrEdit = false
    },
    uploadImg1 (name) {
      let file = this.$refs[name].files[0]
      this.formApk.app_icon = file
      this.formApk.fileName = file.name
      this.imgUrl = URL.createObjectURL(file)
    },
    changeAuditState (val) {
      console.log(val)
      if (val) {
        this.loadData(val)
      }
    },
    clearAuditState () {
      this.loadData()
    },
    // 加载tabs列表
    loadData (state = '') {
      let params = {
        page_size: this.pageSize,
        page: this.current,
        sort: 'updated_at desc',
        tvid: this.tvid,
        query: state
      }
      https.request({
        method: 'get',
        url: '/v2/es/appvertest/list',
        params: params
      }).then(res => {
        // if (res.data.items.length === 0) {
        //   this.$router.push({
        //     path: `/developer/esAppTest`
        //   })
        //   return
        // }
        this.tableLoading = false
        this.dataList = res.data.items
        this.total = res.data.total
        // this.setData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getChannelList (params) {
      https.request({
        method: 'get',
        url: '/v2/es/channels',
        params: {
          page_size: 100
        }
      }).then(res => {
        console.log(res.data.items)
        this.channelList = []
        res.data.items.map(item => {
          if (item.apk_type === 1) {
            this.channelList.push(item)
          }
        })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getVersion () {
      return new Promise(resolve => {
        https.request({
          method: 'get',
          url: '/v1/tvpver/sdkver'
        }).then(res => {
          this.sdkVersion = res.data.list
          resolve()
          // this.setData()
        }).catch(error => {
          this.$Message.error(error)
        })
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    uploadImg (name) {
      let file = this.$refs[name].files[0]
      // console.log(file)
      this.formValidate.files = file
      this.formValidate.fileName = file.name
    },
    getPreCode (type, row) {
      this.pre_env = type
      this.preShow = true
      this.package_ver = row.package_ver
      this.preValidate = {
        params: '',
        qrCode: ''
      }
    },
    copyCode () {
      const params = {
        query: `tvid_ver=${this.tvid}_${this.package_ver}`
      }
      https.request({
        method: 'get',
        url: '/v1/miniprogram/app/share',
        params: params
      }).then(res => {
        this.copyToClip(res.data)
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getCode () {
      const params = {
        // id: this.tvid,
        // params: this.preValidate.params,
        // source: this.pre_env,
        // package_ver: this.package_ver,
        query: `tvid_ver=${this.tvid}_${this.package_ver}`
      }
      // console.log(params)
      https.request({
        method: 'get',
        url: '/v1/miniprogram/qrcode',
        params: params
      }).then(res => {
        this.preValidate.qrCode = `data:image/png;base64,${res.data}`
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    newAlert (index) {
      this.$refs['formValidate'].resetFields()
      this.formValidate.files = ''
      this.newdata = true
    },
    generateApk () {
      if (this.dataList.length === 0) {
        this.$Message.error('还没有已经上线的小程序版本，无法生成apk')
        return
      }
      // this.$refs['formApk'].resetFields()
      this.isShowFormApk = true
      console.log(this.formApk)
      // this.formApk.app_pkg = this.$route.query.package_name
      this.getChannelList()
      this.getAppInfoList(this.$route.query.id)
    },
    getAppInfoList (id) {
      https.request({
        method: 'get',
        url: '/v2/es/app',
        params: {
          id: id
        }
      }).then(res => {
        console.log(res)
        this.formApk.app_name = res.data.name
        this.formApk.app_pkg = res.data.package_name
        this.formApk.app_icon = res.data.icon
        this.formApk.apk_pkg = res.data.sd_pkg_name
        let apk_ver_name = []
        if (res.data.apk_ver_name) {
          res.data.apk_ver_name = '1.0.29'
          apk_ver_name = res.data.apk_ver_name.split('.')
          apk_ver_name[apk_ver_name.length - 1] = Number(apk_ver_name[apk_ver_name.length - 1]) + 1
          apk_ver_name = apk_ver_name.join('.')
        }
        this.formApk.start_ver = apk_ver_name || '1.0.0'
        this.top_ver = res.data.apk_ver_name
        this.imgUrl = res.data.icon
      })
    },
    apkVersion () {
      this.isShowApkVersion = true
      // this.ApkVersionList = []
      https.request({
        method: 'get',
        url: '/v2/es/apks',
        params: {
          package_name: this.$route.query.package_name
        }
      }).then(res => {
        this.apksList = res.data.items
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    apkData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            let arr = []
            this.channelList.map(item => {
              this.formApk.channel_ids.map(items => {
                if (item.name === items) {
                  arr.push(item.id)
                }
              })
            })
            this.changeLoading()
            if (arr.length === 0) {
              this.$Message.error('请选择渠道')
              return
            }
            this.apkProgress = 0
            this.apkDataloading = true
            let params = new FormData()
            params.append('app_name', this.formApk.app_name)
            params.append('app_pkg', this.formApk.app_pkg)
            if (this.formApk.app_icon.name) {
              params.append('app_icon', this.formApk.app_icon)
            }
            params.append('apk_pkg', this.formApk.apk_pkg)
            params.append('channel_ids', arr.toString())
            params.append('startup_args', this.formApk.startup_args)
            params.append('start_ver', this.formApk.start_ver)
            https.request({
              method: 'post',
              url: '/v2/es/apk/task',
              data: params
            }).then(res => {
              if (res.code === 200) {
                this.apkBuild(res.data.task_id)
              }
            }).catch(error => {
              this.$Message.error(error)
            })
          }, 1000)
        }
      })
    },
    apkBuild (id) {
      let params = new FormData()
      params.append('task_id', id)
      setTimeout(() => {
        this.changeLoading()
        https.request({
          method: 'post',
          url: '/v2/es/apk/build',
          data: params
        }).then(res => {
          // this.$Message.success('上传成功')
          console.log(res)
          // this.apkStatus(res.data.items[0].id)
          this.apkStatus(id)
        }).catch(error => {
          this.$Message.error(error)
        })
      }, 1000)
    },
    apkStatus (id) {
      this.startApk = true
      this.apkDataloading = false
      let timer = setInterval(() => {
        https.request({
          method: 'get',
          url: '/v2/es/apk/task/status',
          params: {
            task_id: id
          }
        }).then(res => {
          if (res.code === 200) {
            if (res.data.progress === 1) {
              this.apkProgress = 100
              this.startApk = false
              this.formApk.channel_ids = []
              clearInterval(timer)
            } else if (res.data.progress < 0.4) {
              this.apkProgress = 35
            } else if (res.data.progress >= 0.4) {
              this.apkProgress = res.data.progress * 100
            }
          }
        })
      }, 5000)
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            let params = new FormData()
            params.append('tvid', this.tvid)
            params.append('files', this.formValidate.files)
            params.append('package_ver', this.formValidate.package_ver)
            params.append('remark', this.formValidate.remark)
            params.append('refresh', this.formValidate.refresh === '关闭' ? 2 : 1)
            params.append('sdk_ver_s', this.formValidate.sdk_ver_s === 'all' ? '' : this.formValidate.sdk_ver_s)
            params.append('sdk_ver_e', this.formValidate.sdk_ver_e === 'all' ? '' : this.formValidate.sdk_ver_e)
            https.request({
              method: 'post',
              url: '/v2/es/appvertest/add',
              data: params,
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(res => {
              this.changeLoading()
              if (res.data && res.data.code === 400) {
                this.$Message.error(res.data.msg)
                return
              }
              this.$Message.success('上传成功')
              this.newdata = false
              this.loadData()
            }).catch(error => {
              this.$Message.error(error)
            })
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    delItem (index) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p class="del-modal-txt">确定要删除 <span>' + this.dataList[index].name + '</span> 吗？</p>',
        onOk: () => {
          https.request({
            method: 'delete',
            url: '/v1/application/' + this.dataList[index].id
          }).then(res => {
            this.$Message.success('删除成功')
            if (this.dataList.length === 1 && this.current > 1) this.current -= 1
            this.loadData()
          }).catch(error => {
            this.$Message.error(error)
          })
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    },
    copyToClip (content) {
      var aux = document.createElement('input')
      aux.setAttribute('value', content)
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      this.$Message.success('复制成功')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .code-box {
    display: inline-block;
    border: 1px solid #dcdee2;
    padding: 15px;
    text-align: center;
    line-height: 1;
  }
  .code-box p {
    margin-top: 15px;
  }
  .code-box img {
    width:200px;
    height:200px;
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 260px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select-box-name{
    display: flex;
    position: absolute;
    top: 20px;
    right:28px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select_icon_url{
    width: 30px;
    height: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/esAppTest/versionTest.vue